import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { SyncType } from '@era/locations-sdk';
import { DeviceStoreActions, DeviceStoreStates, LocationSubset } from '@era/stores';
import { Store } from '@ngrx/store';
import { SyncTypeFilter } from './devices-sync-filter';
import { map, Observable } from 'rxjs';
import { isAdmin } from '@era/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { PaneComponent } from '../../../core/layout/pane/pane.component';
import { DevicesSyncModalComponent } from './devices-sync-modal.component';
import { AsyncPipe } from '@angular/common';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'era-devices-sync-modal-container',
  templateUrl: './devices-sync-modal.container.html',
  styleUrls: ['./devices-sync-modal.container.scss'],
  imports: [PaneComponent, DevicesSyncModalComponent, AsyncPipe],
})
export class DevicesSyncModalContainerComponent {
  @Input() public locationSubset = LocationSubset.All;
  private readonly syncTypes: SyncType[] = new Array<SyncType>();
  public isAdmin$: Observable<boolean>;

  constructor(
    public readonly activeModal: NgbActiveModal,
    private readonly deviceStore: Store<DeviceStoreStates.DeviceState>,
    private readonly oidcService: OidcSecurityService
  ) {
    this.isAdmin$ = this.oidcService.userData$.pipe(map((data) => isAdmin(data)));
  }

  closeModal() {
    this.activeModal.close();
  }

  syncDevices(event: { filter: SyncTypeFilter; force: boolean }) {
    (Object.keys(event.filter) as (keyof typeof SyncType)[]).forEach((syncType) => {
      if (event.filter[syncType] === true) {
        this.syncTypes.push(syncType);
      }
    });

    this.deviceStore.dispatch(
      DeviceStoreActions.DevicesSyncModalActions.syncDevicesRequested({
        locationSubset: this.locationSubset,
        syncTypes: this.syncTypes,
        force: event.force,
      })
    );

    this.activeModal.close();
  }
}
